import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <main className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="payment-cancel-page">
      <h1 className="text-4xl font-bold">Checkout canceled</h1>
      <p className="mt-2 text-[#6E687A]">No worries, you weren't charged.</p>
      <Link to="/studio" className="mt-8 inline-block rounded-full bg-[#1E1B26] text-white px-7 py-3 font-bold" data-testid="payment-cancel-back">Back to the studio</Link>
    </main>
  );
}
